'use strict';

/**
 *
 * @name: nownessApp.category
 *
 */

import CategoryConfig from './category.config';
import ModuleCoverCategoryDirective from './module-cover-category/module-cover-category.directive';
import NnPreviouslyInCategoryDirective from './nn-previously-in-category/nn-previously-in-category.directive';
import CategoryAnalyticsFactory from './category-analytics.factory';

const CategoryModule = angular
  .module('nownessApp.category', [])
  .config(CategoryConfig)
  .factory('CategoryAnalyticsFactory', CategoryAnalyticsFactory)
  .directive('moduleCoverCategory', ModuleCoverCategoryDirective)
  .directive('nnPreviouslyInCategory', NnPreviouslyInCategoryDirective);

export default CategoryModule.name;



// WEBPACK FOOTER //
// ./app/pages/category/category.module.js